import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import css from "./LeadCountByEpid.module.css";
import clsx from "clsx";

interface LeadCountByEpidProps {
    epid: string;
    count: number;
}

export const LeadCountByEpid = (data: LeadCountByEpidProps) => {

    return (
        <Box className={clsx(css.leadCountByEpid)}>

            <Box className={clsx(css.item)}>
                <Typography variant="body2">Epid</Typography>
                <Typography variant="h6">{data.epid}</Typography>
            </Box>

            <Box className={clsx(css.item)}>
                <Typography variant="body2">Ilość lidów</Typography>
                <Typography variant="h6">{data.count}</Typography>
            </Box>

        </Box>
    );
};

